// **************************************************
//
// IMPORT
//
// **************************************************
const THREE = require('three')
import store from 'src/store'
import fileExtension from 'file-extension'
import Queue from 'promise-queue'
import delayPromise from 'src/lib/delay-promise'
// var config = require('src/../config')


// **************************************************
//
// DATA LOADER
//
// **************************************************
class DataLoader extends THREE.Loader {

  // constructor () {
  //   super()
  // }

  load (url, onLoad, onProgress, onError) {
    var scope = this

    var loader = new THREE.FileLoader(scope.manager)
    loader.load(url, function (text) {
      onLoad(JSON.parse(text))
    }, onProgress, onError)
  }

}


// **************************************************
//
// MANAGER
//
// **************************************************
export let assets = {}
export let sizes = {}
let loaders = {
  jpg: THREE.ImageLoader,
  json: DataLoader,
  ttf: DataLoader,
  otf: DataLoader,
  m4a: THREE.AudioLoader,
  mp3: THREE.AudioLoader,
  mp4: THREE.AudioLoader,
  ogg: THREE.AudioLoader,
  png: THREE.ImageLoader,
  three: THREE.ObjectLoader,
  obj: THREE.OBJLoader,
  mtl: THREE.MTLLoader,
  dae: THREE.ColladaLoader,
  two: THREE.JSONLoader,
  wav: THREE.AudioLoader
}

export let loadingManager = new THREE.LoadingManager()
export default loadingManager
export let progress = 0

export const getProgress = function () {
  let loaded = 0
  let total = 0
  for (let url in assets) {
    let asset = assets[url]
    loaded += asset.progress.loaded
    total += asset.progress.total
  }
  if (total > 0) {
    progress = loaded / total
    store.commit('game/loadProgress', progress)
    if (progress >= 1) {
      store.commit('game/loadComplete')
    }
  }
  return progress
}



// **************************************************
//
// PRESET SIZE
//
// **************************************************
export const registerSize = function (url, size) {
  sizes[url] = size
}


// export const register = function (url, size, onLoaded) {
//   let asset = assets[url] || {
//     onLoaded: [],
//     progress: {
//       loaded: 0,
//       total: sizes[url] || 0,
//       percent: 0
//     },
//     result: null
//   }
//   assets[url] = asset
//   asset.progress.total = size
//   asset.onLoaded.push(onLoaded)
// }


export const getTotalSize = function () {
  let size = 0
  for (let key in assets) {
    size += assets[key].progress.total
  }
  return size
}

// **************************************************
//
// LOAD
//
// **************************************************
export const load = function (url, loader, onLoaded) {

  let asset = assets[url]

  // Already loaded or being loaded
  if (asset && onLoaded) {
    if (asset.result) {
      onLoaded(asset.result)
    } else {
      asset.onLoaded.push(onLoaded)
    }
    return
  }

  // New load
  asset = {
    url: url,
    loader: loader,
    onLoaded: [],
    progress: {
      started: false,
      loaded: 0,
      total: sizes[url] || 0,
      percent: 0
    },
    results: null
  }
  assets[url] = asset
  if (onLoaded) asset.onLoaded.push(onLoaded)

}


export const loadItem = function (asset) {

  return new Promise((resolve)=> {

    const onLoad = function (...results) {
      if (asset.results === null) asset.results = results

      if (asset.progress.total > 0) {
        if (asset.progress.loaded < asset.progress.total) {
          asset.progress.loaded = asset.progress.total
        }
      } else {
        asset.progress.total = asset.progress.loaded
      }
      asset.progress.percent = 1

      // console.log(111, asset.url, asset.results, asset.onLoaded.length)
      while (asset.onLoaded.length) {
        const cb = asset.onLoaded.pop()
        cb(asset.results)
      }
      // for (let cb of asset.onLoaded) {
      //   cb(results)
      // }

      getProgress()
      resolve()
    }

    const onProgress = function (evt) {
      // console.log(evt)
      asset.progress.loaded = evt.loaded
      if (evt.total > 0) {
        asset.progress.total = evt.total
      }
      if (asset.progress.total > 0) {
        asset.progress.percent = asset.progress.loaded / asset.progress.total
      }
      // getProgress()
    }

    const onError = function (err) {
      console.error('loader.js', asset.url, err.target.statusText)
    }

    // IF ALREADY STARTED / DONE
    if (asset.progress.started) {
      if (asset.results !== null) {
        onLoad(asset.results)
      }
      resolve()
      return
    }

    // Load it
    asset.progress.started = true
    const ext = fileExtension(asset.url)
    let loader = asset.loader || new loaders[ext](loadingManager)
    loader.load(asset.url, onLoad, onProgress, onError)

  })
}

export const start = function () {

  const totalSize = getTotalSize()
  console.log(`Load Size: ${Math.round(totalSize / 1000)}kb`)

  let queue = new Queue(2, Infinity)
  for (let key in assets) {
    const asset = assets[key]
    queue.add(()=> {
      return loadItem(asset)
        .then(()=> {
          return new Promise(function(resolve) {
            setTimeout(function() {
              resolve()
            }, 0)
          })
        })
    })
  }
}






// WEBPACK FOOTER //
// ./src/components/game/loader.js